
import { computed } from "vue";
import { useStore } from "vuex";
import { useToast } from "primevue/usetoast";
import router from "@/router";
import Menu from "primevue/menu";

export default {
  components: { Menu },
  props: {
    isLoggedIn: {
      type: Boolean,
      required: true,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["toggleCollapse", "navigate"],
  setup(props, { emit }) {
    const store = useStore();
    const toast = useToast();
    const defaultMenu = [];
    const userMenu = [
      // {
      //   label:'Thêm tỷ lệ hao hụt',
      //   icon:'pi pi-fw pi-plus-circle',
      //   url: '/drugcreatepage'
      // },
      // {
      //   label:'Thực hiện bào chế thuốc',
      //   icon:'pi pi-fw pi-sync',
      //   url: '/detailpage'
      // },
      // {
      //   label:'Thống kê ds thuốc bào chế',
      //   icon:'pi pi-fw pi-list',
      //   url: '/statisticalpage'
      // }

      // {
      //   label:'Tiếp nhận thiết bị',
      //   icon:'pi pi-fw pi-plus-circle',
      //   url: '/inputDevice'
      // },
      {
        label: "Tình trạng thiết bị ",
        icon: "pi pi-fw pi-briefcase",
        to: "/managerDevicePage",
      },
      {
        label: "Quản lý toàn bộ thiết bị",
        icon: "pi pi-fw pi-list",
        to: "/allDevicePage",
      },
    ];
    const adminMenu = [
      {
        label: "Tiếp nhận thiết bị",
        icon: "pi pi-fw pi-plus-circle",
        to: "/inputDevice",
      },
      {
        label: "Tình trạng thiết bị",
        icon: "pi pi-fw pi-briefcase",
        to: "/managerDevicePage",
      },
      {
        label: "Quản lý toàn bộ thiết bị",
        icon: "pi pi-fw pi-list",
        to: "/allDevicePage",
      },
      {
        label: "Xuất báo cáo",
        icon: "pi pi-fw pi-file-export",
        to: "/reportPage",
      },
      {
        label: "Danh sách tài khoản",
        icon: "pi pi-fw pi-users",
        to: "/userlist",
      },
      {
        label: "Đăng ký tài khoản mới",
        icon: "pi pi-fw pi-user-plus",
        to: "/registerpage",
      },
    ];
    const appMenus = computed(() => {
      if (store.state.permission == "admin") return adminMenu;
      else if (store.state.permission == "user") return userMenu;
      else return defaultMenu;
    });
    const logout = () => {
      store.dispatch("clearToken");
      store.dispatch("clearPermission");
      store.dispatch("clearFullName");
      store.dispatch("clearTeam");
      router.push({
        name: "login",
      });
      toast.add({
        severity: "success",
        summary: "Đăng xuất",
        detail: "Đã xóa thông tin đăng nhập thành công",
        life: 1000,
      });
    };

    return {
      appMenus,
      logout,
      showCollapse: computed(() => true),
      emitNavigate: () => emit("navigate"),
    };
  },
};
